export default "__VITE_ASSET__b54eaa30__"